module.exports = __webpack_public_path__ + "static/img/credential2.1ae923f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/credential/credential2.jpg
// module id = +e9o
// module chunks = 1